export const features = [
  {
    id: 'feature-1',
    icon: 'ri-shield-check-line',
    title: '安全访问保障',
    description: '所有官方入口均经过严格安全验证，采用HTTPS加密传输，确保您的访问安全无忧，远离恶意网站和钓鱼陷阱。',
  },
  {
    id: 'feature-2',
    icon: 'ri-flashlight-line',
    title: '最新资源速递',
    description: '实时同步平台最新更新内容，热门漫画第一时间推送，让您永远走在漫画潮流的最前端。',
  },
  {
    id: 'feature-3',
    icon: 'ri-book-open-line',
    title: '海量正版内容',
    description: '汇聚数万部正版授权漫画作品，涵盖热血、恋爱、奇幻、悬疑等全品类，满足各种阅读口味。',
  },
  {
    id: 'feature-4',
    icon: 'ri-vip-crown-line',
    title: '会员专属权益',
    description: '会员享受无广告阅读、高清画质、离线下载、抢先观看等专属特权，尊享极致阅读体验。',
  },
];

export const stats = [
  { value: '50,000+', label: '正版漫画' },
  { value: '1,200万+', label: '注册用户' },
  { value: '99.9%', label: '服务可用率' },
  { value: '24/7', label: '客服支持' },
];

export const testimonials = [
  {
    id: 'testimonial-1',
    name: '小明',
    role: '资深漫画迷',
    content: '用禁漫天堂已经三年了，资源更新速度真的很快，画质也非常清晰，是我用过最好的漫画平台！',
    rating: 5,
  },
  {
    id: 'testimonial-2',
    name: '阿花',
    role: '二次元爱好者',
    content: '分类做得特别细致，找漫画非常方便。会员价格也很合理，充一次能用好久，强烈推荐！',
    rating: 5,
  },
  {
    id: 'testimonial-3',
    name: '老王',
    role: '上班族读者',
    content: '通勤路上的最佳伴侣，离线下载功能太实用了。界面简洁没有广告，阅读体验一流。',
    rating: 4,
  },
];